import Vue from 'vue'
import Router from 'vue-router'

import LayoutDefault from '@/components/Layouts/Default'
import LayoutEditor from '@/components/Layouts/Editor'

import MagicSignUp from '@/components/Authentication/MagicSignUp'
import MagicSignIn from '@/components/Authentication/MagicSignIn'
import PasswordSignUp from '@/components/Authentication/PasswordSignUp'
import PasswordSignIn from '@/components/Authentication/PasswordSignIn'
import People from '@/components/People/People'
import PeopleAdd from '@/components/People/Add'
import Person from '@/components/People/Person'
import Opportunities from '@/components/Opportunities/Opportunities'
import OpportunitiesAdd from '@/components/Opportunities/Add'
import Organizations from '@/components/Organizations/Organizations'
import OrganizationAdd from '@/components/Organizations/Add'
import Organization from '@/components/Organizations/Organization'
import Inventions from '@/components/Inventions/Inventions'
import InventionSolution from '@/components/Inventions/Solution'
import InventionPresentation from '@/components/Inventions/Presentation'
import Profile from '@/components/User/Profile'
import ProfileEdit from '@/components/User/ProfileEdit'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/signup',
      name: 'MagicSignUp',
      component: MagicSignUp
    },
    {
      path: '/signin',
      name: 'MagicSignIn',
      component: MagicSignIn
    },
    {
      path: '/password-signin',
      name: 'PasswordSignIn',
      component: PasswordSignIn
    },
    {
      path: '/password-signup',
      name: 'PasswordSignUp',
      component: PasswordSignUp
    },
    {
      path: '/',
      component: LayoutDefault,
      name: 'Default',
      redirect: to => {
        if (window.localStorage.prolific_authorization) {
          if (window.localStorage.prolific_authorization_isGod === 'yes') {
            return {
              name: 'People'
            }
          } else {
            return {
              name: 'Inventions'
            }
          }
        } else {
          return {
            name: 'MagicSignIn'
          }
        }
      },
      children: [
        {
          path: '/people',
          name: 'People',
          component: People
        },
        {
          path: '/people/add',
          name: 'PeopleAdd',
          component: PeopleAdd
        },
        {
          path: '/people/person/:id',
          name: 'Person',
          component: Person
        },
        {
          path: '/people/person/:id/edit',
          name: 'PersonEdit',
          component: PeopleAdd
        },
        {
          path: '/opportunities',
          name: 'Opportunities',
          component: Opportunities
        },
        {
          path: '/opportunities/opportunity/add',
          name: 'OpportunitiesAdd',
          component: OpportunitiesAdd
        },
        {
          path: '/opportunities/opportunity/:id/edit',
          name: 'OpportunityEdit',
          component: OpportunitiesAdd
        },
        {
          path: '/organizations',
          name: 'Organizations',
          component: Organizations
        },
        {
          path: '/organizations/add',
          name: 'OrganizationAdd',
          component: OrganizationAdd
        },
        {
          path: '/organizations/organization/:id',
          name: 'Organization',
          component: Organization
        },
        {
          path: '/organizations/organization/:id/edit',
          name: 'OrganizationEdit',
          component: OrganizationAdd
        },
        {
          path: 'inventions',
          component: Inventions,
          name: 'Inventions'
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: '/profile/edit',
          name: 'ProfileEdit',
          component: ProfileEdit
        }
      ]
    },

    {
      path: '/',
      component: LayoutEditor,
      children: [
        {
          path: '/inventions/:id',
          name: 'InventionSolution',
          component: InventionSolution
        },
        {
          path: '/inventions/:id/present',
          name: 'InventionPresentation',
          component: InventionPresentation
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js